/* eslint react/prop-types: 0 */
import React from 'react';

const EyeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    aria-labelledby="title"
    aria-describedby="desc"
    role="img"
  >
    <title>Eye</title>
    <desc>A line styled icon from Orion Icon Library.</desc>
    <path
      data-name="layer2"
      d="M32 14.5C14.8 14.5 2.5 32 2.5 32S14.8 49.5 32 49.5 61.5 32 61.5 32 49.2 14.5 32 14.5z"
      fill="none"
      stroke="#202020"
      strokeMiterlimit="10"
      strokeWidth="2"
      strokeLinejoin="round"
      strokeLinecap="round"
    ></path>
    <circle
      data-name="layer1"
      cx="32"
      cy="31.5"
      r="10"
      fill="none"
      stroke="#202020"
      strokeMiterlimit="10"
      strokeWidth="2"
      strokeLinejoin="round"
      strokeLinecap="round"
    ></circle>
    <path
      data-name="layer1"
      d="M28.5 29.5a4 4 0 0 0 3.5 6"
      fill="none"
      stroke="#202020"
      strokeMiterlimit="10"
      strokeWidth="2"
      strokeLinejoin="round"
      strokeLinecap="round"
    ></path>
  </svg>
);

export default EyeIcon;
